export const Reveal = ({ children, className = "" }) => (
  <div className={className}>{children}</div>
);

export const MaskLines = ({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.14 }) => (
  <span className={`block ${className}`}>
    {lines.map((line, i) => (
      <span key={i} className={`mask-line ${lineClassName}`}>
        <span className="mask-inner" style={{ animationDelay: `${delay + i * stagger}s` }}>
          {line}
        </span>
      </span>
    ))}
  </span>
);

export const Stagger = ({ children, className = "" }) => (
  <div className={className}>{children}</div>
);

export const StaggerItem = ({ children, className = "" }) => (
  <div className={className}>{children}</div>
);
